import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

// Admin-only: reads the customer's LIVE payment methods directly from Stripe
// (not our local cache) so an admin can verify what's actually on file.
const FamilyStripePaymentMethodsQuery = graphql.persisted(
  "FamilyStripePaymentMethods",
  graphql(`
    query FamilyStripePaymentMethods($familyEnrollmentId: ID!) {
      familyStripePaymentMethods(familyEnrollmentId: $familyEnrollmentId) {
        paymentMethodId
        paymentType
        last4
        brand
        linkEmail
        isDefault
      }
    }
  `)
);

export { FamilyStripePaymentMethodsQuery };

// Skipped by default — this hits Stripe's API directly, so callers should only
// enable it on demand (e.g. an admin opens a "verify against Stripe" panel).
export function useFamilyStripePaymentMethodsQuery(familyEnrollmentId?: string, options?: { skip?: boolean }) {
  return useQuery(FamilyStripePaymentMethodsQuery, {
    variables: { familyEnrollmentId: familyEnrollmentId! },
    skip: !familyEnrollmentId || options?.skip !== false,
  });
}
